import { Component, Injector } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AppDetailsService} from "../../../services/app.details.service";
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { propertiesToJson } from 'properties-file/content'
import { HttpBackend, HttpClient } from "@angular/common/http";

declare var ENVIRONMENT_CONFIG: any;

@Component({
    selector: 'app-details-dialog',
    templateUrl: './app-details-dialog.component.html'
})
export class AppDetailsDialogComponent extends BaseDialogComponent {

    public fundraisingToolsApp: any;
    public logicalApiApp: any;
    public buildProperties: any;
    private http: HttpClient;

    constructor(
        public activeModal: NgbActiveModal,
        public appDetailsService: AppDetailsService,
        private handler: HttpBackend,
        injector: Injector
    ) {
        super(injector);

        this.http = new HttpClient(handler);

        this.http.get('build.properties', { responseType: "text" }).subscribe((resp) => {
            this.buildProperties = propertiesToJson(resp);
        } )
    }

    public closeDialog() {
        this.activeModal.close();
    }

    get environmentConfig() {
        return ENVIRONMENT_CONFIG;
    }

    get uiBuildNumber() {
        let uiBuildNumber: string = this.buildProperties ? this.buildProperties["SCM-Branch"] : '';
        return uiBuildNumber;
    }
}
